import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
// import LogoImg from "../../assets/svg/Logo";
import LogoImg from "../../assets/jpg_png/logo.png";
import instagram from "../../assets/jpg_png/instagram.svg";
import facebook from "../../assets/jpg_png/facebook.svg";
import youtube from "../../assets/jpg_png/youtube.svg";
import twitter from "../../assets/jpg_png/twitter.svg";
import linkedin from "../../assets/jpg_png/linkedin.svg";
import gmail from "../../assets/jpg_png/gmail.svg";
import call from "../../assets/jpg_png/call.svg";

//Css
import "../../style/TopNavbar.css";

//Icons
import { AiFillYoutube } from "react-icons/ai";
export default function Contact() {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper
            className="flexSpaceCenter"
            style={{ padding: "30px 0" }}
          >
            <Link
              className="flexCenter animate pointer logo-Css"
              to="home"
              smooth={true}
              offset={-80}
            >
              <img src={LogoImg} alt="LogoIcon" />
              <h1
                className="font15 extraBold whiteColor"
                style={{ marginLeft: "15px" }}
              >
                NLITE INTERIORS
              </h1>
            </Link>

            <StyleP className="whiteColor font13">
              <div className="Social-Media_Icons">
                <a
                  href="https://www.youtube.com/channel/UCka69KxLhkTcbb7cbRd71Sg"
                  target="_blank"
                >
                  <img src={youtube} alt="" />
                </a>
                <a
                  href="https://www.instagram.com/nliteinteriors/?igshid=ZDdkNTZiNTM%3D"
                  target="_blank"
                >
                  <img src={instagram} alt="" />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=100092311800073"
                  target="_blank"
                >
                  <img src={facebook} alt="" />
                </a>
                <a href="https://twitter.com/NliteIInteriors" target="_blank">
                  {" "}
                  <img src={twitter} alt="" />
                </a>
                <a
                  href="https://www.linkedin.com/in/nlite-interiors-54145a26a/"
                  target="_blank"
                >
                  {" "}
                  <img src={linkedin} alt="" />
                </a>
                <a href="mailto:nliteinteriors@gmail.com" target="_blank">
                  <img src={gmail} alt="" />
                </a>
                <a href="tel:6303435214">
                  {" "}
                  <img src={call} alt="" />
                </a>
              </div>
              © {getCurrentYear()} -{" "}
              <span
                className="purpleColor font15"
                style={{ color: "#efbc4a", fontWeight: "700" }}
              >
                NLITE INTERIORS
              </span>{" "}
              All Right Reserved
            </StyleP>

            <Link
              className="whiteColor animate pointer font13"
              to="home"
              smooth={true}
              offset={-80}
            >
              Back to top
            </Link>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;
const StyleP = styled.p`
  text-align: center;
  font-size: 15px;
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;
